var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 286 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ff7900;\n      }\n\n      .st1 {\n        fill: #eb5b00;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,35.56c.69-.01,1.62.01,2.32,0,0,1.3-1.1,2.79-2.11,3.1.7,0,1.39-.01,2.09-.02v4.29h-8.43v-4.28c.36,0,.73-.01,1.09-.02.51.03,1.63.02,2.84-.6,1.84-.94,2.04-2.05,2.2-2.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.59,34.59h-.03s-12.53-.11-12.53-.11l.06-6.47,12.52.11c3.21,0,5.82-2.62,5.82-5.83s-2.62-5.83-5.83-5.83h-8.35v-6.47h8.35c6.79,0,12.31,5.52,12.31,12.31s-5.52,12.31-12.31,12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.98,34.61h-.03s-12.53-.11-12.53-.11l.06-6.47,12.52.11c3.21,0,5.82-2.62,5.82-5.83s-2.62-5.83-5.83-5.83h-1.95v3.04h-6.47v-9.52h8.43c6.79,0,12.31,5.52,12.31,12.31s-5.52,12.31-12.31,12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.26,34.48h-17.51c-3.12,0-5.65-2.54-5.65-5.65v-10.09c0-4.89,3.98-8.86,8.86-8.86h12.27v16.03h-6.47v-9.55h-5.79c-1.32,0-2.39,1.07-2.39,2.39v9.27h16.69v6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.87,43.88h-5.99v-6.47h5.99c2.21,0,7.41-1.8,7.41-4.02v-2.15h6.47v2.15c0,5.78-8.1,10.49-13.89,10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.4,44.01h-9.36c-6.09,0-11.05-4.96-11.05-11.05v-10.66h6.47v10.66c0,2.52,2.05,4.57,4.57,4.57h9.36c3.4,0,6.17-2.77,6.17-6.17h6.47c0,6.97-5.67,12.64-12.64,12.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "165.15 9.12 145.23 9.12 145.23 6.84 165.15 .23 165.15 9.12"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.41.25c3.48-.07,8.13.07,11.6,0,0,6.54-5.52,13.96-10.59,15.53,3.49-.03,6.98-.06,10.48-.08v28.52h-42.25V15.71c1.82-.03,3.64-.06,5.47-.08,2.54.17,8.17.12,14.25-3,9.24-4.73,10.2-10.26,11.04-12.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 174.65,
    y: 15.71,
    width: 42.25,
    height: 28.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullHorizontal);
export default __webpack_public_path__ + "static/media/full-horizontal.eb56a568c48b7ea080b4215b25928aff.svg";
export { ForwardRef as ReactComponent };